export default __webpack_public_path__ + "4821eb773bcb86fe1efc66e8806326d9.png";